import { normalizeCoordinate } from '../helpers';

function DrawPentagonArea({
  area,
  transparent,
  pentagonWidth,
  pentagonHeight,
  areaTooltip,
  setAreaTooltip,
  pointTooltip,
}) {
  const { points, fill, name } = area;
  let pointsString = '';
  for (const point of points) {
    pointsString += `${pentagonWidth / 2 + pentagonWidth * (normalizeCoordinate(point[0]) / 100)},${pentagonHeight / 2 + pentagonHeight * (normalizeCoordinate(point[1]) / 100)} `;
  }

  function showTooltip(event) {
    if (areaTooltip.show || pointTooltip.show) {
      return;
    }
    setAreaTooltip({
      show: true,
      position: { x: event.clientX, y: event.clientY },
      text: name,
    });
  }

  return (
    <polygon
      className="area"
      points={pointsString}
      strokeWidth={1}
      fill={transparent ? 'transparent' : fill}
      onMouseOut={() => {
        setAreaTooltip((prev) => ({ ...prev, show: false }));
      }}
      onMouseOver={showTooltip}
    />
  );
}

export default DrawPentagonArea;
